import { render, staticRenderFns } from "./StatInspItemList.vue?vue&type=template&id=ad3ce64e"
import script from "./StatInspItemList.vue?vue&type=script&lang=js"
export * from "./StatInspItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports